export const AGE_VERIFICATION_FOR_SSC = false
export const IS_LAST_PAYMENT_ENABLED = true
export const IS_SHOW_DOB = true
export const IS_GUEST_ENABLED = true
export const IS_SHOW_SHIPMENT_LINKS = false
export const IS_BLOG_ENABLED = false
export const GUEST_GTM_EVENT = false
export const STOCK_STATUS_CLICKABLE = true
export const IS_DEFAULT_BREADCRUMB_ENABLED = true
export const IS_STORE_CREDIT_ENABLED = false
export const TERMS_LINK = 'content/terms-of-service'
export const PRIVACY_LINK = 'content/privacy-policy-cookie-restriction-mode'
export const IS_YOUTUBE_SEO_ENABLED = true
export const IS_CHECKOUT_AGREEMENTS = true
export const IS_SEPARATE_PAGE = false
export const IS_SUBSCRIPTION_ENABLED = true
export const IS_AGE_VERFICATION_ON_ACCOUNT_PAGE = true
export const ALL_BRAND_PAGE_URL = 'shop-by-brand'
